import {
  SravniIdentityClientsSubscriptionInfo,
  SravniNewsSharedEnumsDictionaryType,
  SravniNewsSharedModelsOrganizationData,
} from '../__generated__/news/Api';
import {
  IAdditionalReadingQuery,
  IDictionaryDto,
  IHighlightedMaterial,
  IMaterial,
  IMaterialHighlightsList,
  IMaterialsListQuery,
  IOneMoreArticleQuery,
  IPartnersInfoResult,
  IPartnersMaterialsQuery,
  IPlacementQuery,
  IRubricDictionaryResult,
  TAdditionalReading,
  TAuthorShort,
  TAuthorsQuery,
  TMaterialHighlightsList,
  TMaterialHighlightsListQuery,
  TMaterialList,
  TMaterialListQuery,
  TMaterialQuery,
  TMaterialSingleQuery,
  TMaterialsPopularQuery,
  TOrganizationsInfoQuery,
  TPartnerMaterial,
  TPartnersInfoQuery,
  TPlacementConfigurationShortMap,
  TRubricsListQuery,
  TRubricTagsQuery,
  TSearchQuery,
  TTag,
} from '../interfaces/news';

import { ProxyClient } from './client/ProxyClient';

export const getMaterialsList = async (params: TMaterialListQuery) => {
  const { data } = await ProxyClient.get<IHighlightedMaterial[]>('/news/highlights', { params });

  return data;
};

export const getHighlightsV2 = async (params: IMaterialsListQuery) => {
  const { data } = await ProxyClient.get<IHighlightedMaterial[]>('/news/highlightsV2', { params });

  return data;
};

export const getMaterialByAlias = async (params: TMaterialSingleQuery) => {
  const { data } = await ProxyClient.get<IMaterial>('/news/material', { params });

  return data;
};

export const getMaterialById = async (params: TMaterialQuery) => {
  const { data } = await ProxyClient.get<IMaterial>(`/news/material/${params.id}`);
  return data;
};

export const getAllPlacements = async () => {
  const { data } = await ProxyClient.get<TPlacementConfigurationShortMap>('/news/placements');

  return data;
};

export const getOneMoreArticle = async (params: IOneMoreArticleQuery) => {
  const { data } = await ProxyClient.get<IMaterial>('/news/one-more-article', { params });

  return data;
};

export const getOneMoreArticleV2 = async (params: IOneMoreArticleQuery) => {
  const { data } = await ProxyClient.get<IMaterial>('/news/one-more-articleV2', { params });
  return data;
};

export const getPlacement = async (params: IPlacementQuery) => {
  const { data } = await ProxyClient.get<IMaterial>('/news/placement', { params });
  return data;
};

export const getPartnerMaterials = async (params: IPartnersMaterialsQuery) => {
  const { data } = await ProxyClient.get<TPartnerMaterial[]>('/news/partner-materials', { params });

  return data;
};

export const getAdditionalReading = async (params: IAdditionalReadingQuery) => {
  const { data } = await ProxyClient.get<TAdditionalReading[]>('/news/additional-reading', { params });

  return data;
};

export const getRubricsList = async (params: TRubricsListQuery) => {
  const { data } = await ProxyClient.get<IRubricDictionaryResult>('/news/rubrics', { params });

  return data;
};

export const getTagsByRubric = async (params: TRubricTagsQuery) => {
  const { data } = await ProxyClient.get<TTag[]>('/news/tags-by-rubric', { params });

  return data;
};

export const getDictionary = async () => {
  const { data } = await ProxyClient.get<{ [key in SravniNewsSharedEnumsDictionaryType]: IDictionaryDto[] }>(
    '/news/dictionary',
  );

  return data;
};

export const increaseVisit = async (id: number) => {
  return await ProxyClient.patch(`/news/${id}/visit-increase`);
};

export const getAuthorsList = async (params: TAuthorsQuery) => {
  const { data } = await ProxyClient.get<TAuthorShort[]>('/news/authors', { params });

  return data;
};

export const getUserSubscriptions = async () => {
  const { data } = await ProxyClient.get<SravniIdentityClientsSubscriptionInfo['types']>('/get-user-subscriptions');
  return data;
};

export const getPartnersInfo = async (params: TPartnersInfoQuery) => {
  const { data } = await ProxyClient.get<IPartnersInfoResult>('/news/partnersInfo', { params });
  return data;
};

export const getOrganizationsInfo = async (params: TOrganizationsInfoQuery) => {
  const { data } = await ProxyClient.get<SravniNewsSharedModelsOrganizationData[]>('/news/organizationsInfo', {
    params,
  });

  return data;
};

export const getPopularMaterials = async (params: TMaterialsPopularQuery) => {
  const { data } = await ProxyClient.get<TMaterialHighlightsList>('/news/popular', { params });
  return data;
};

export const getPopularHighlights = async (params: TMaterialsPopularQuery) => {
  const { data } = await ProxyClient.get<IMaterialHighlightsList>('/news/popular/highlights', { params });
  return data;
};

export const getHighlightsList = async (params: TMaterialHighlightsListQuery) => {
  const { data } = await ProxyClient.get<TMaterialHighlightsList>('/news/highlightsList', { params });
  return data;
};

export const getMaterials = async (params: TMaterialListQuery) => {
  const { data } = await ProxyClient.get<TMaterialList>('/news/materials', { params });
  return data;
};

export const searchMaterials = async (params: TSearchQuery) => {
  const { data } = await ProxyClient.get<IHighlightedMaterial[]>('/news/search', { params });

  return data;
};
